const $referencesWrapper = $('[data-references-wrapper]');

if ($referencesWrapper.length) {
  const insertUrlParam = (key, value) => {
    if (window.history.pushState) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set(key, value);
      const newUrl = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  };

  const removeUrlParameter = () => {
    const url = window.location.pathname;
    window.history.pushState({}, document.title, url);
  };

  const deactivateFilters = ($triggers, $cards) => {
    $triggers.removeClass('active');
    $cards.closest('.cell').show();
    removeUrlParameter();
  };

  const handleFilter = ($trigger, $filterTriggers, $cards) => {
    if ($trigger.hasClass('active')) {
      deactivateFilters($filterTriggers, $cards);
    } else {
      deactivateFilters($filterTriggers, $cards);
      $trigger.addClass('active');
      $cards.each((i, card) => {
        if (!$(card).data($trigger.data('target'))) {
          $(card).closest('.cell').hide();
        }
      });
      insertUrlParam('filter', $trigger.data('target'));
    }
  };

  const getFilterTag = (slug) => {
    const filterTagMap = {
      'business-intelligence': 'businessintelligence',
      'point-of-sale': 'pointofsale',
      'system-integration': 'systemintegration',
      'comarch-erp-enterprise': 'erp',
      'erp-polynorm-i2': 'erp',
      'mobile-lsungen': 'mobilesolutions',
      edib2b: 'erp',
      ebusiness: 'ebusiness',
      cms: 'business',
      produktkatalog: 'ebusiness',
      // 'xmedia-manager': 'pim',
      // cms: 'cms',
      dms: 'dokumentenmanagementsystem',
      datenmanagement: slug,
    };

    return filterTagMap[slug] || '';
  };

  const slugify = text =>
    text
      .toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

  const categoryMap = {
    erp: 'ERP',
    ebusiness: 'E-Business',
    // pim: 'PIM',
    // cms: 'CMS',
    pointofsale: 'Point of Sale',
    businessintelligence: 'Business Intelligence',
    datenmanagement: 'Daten Management',
    dokumentenmanagementsystem: 'DMS',
    mobilesolutions: 'mobile Lösungen',
    systemintegration: 'System Integration',
  };

  const $cards = $referencesWrapper.find('.cms-card');
  if ($cards.length) {
    $cards.each((i, card) => {
      $(card)
        .find('li')
        .each((j, item) => {
          const text = $(item).find('a').text();
          card.setAttribute(`data-${getFilterTag(slugify(text))}`, 1);
        });
    });

    const $referenceFilter = $('<div>', {
      id: 'referenceFilter',
      class: 'poly-reference-filter-wrapper show-for-tablet',
    }).insertBefore($referencesWrapper);

    $('<div>', {
      class: 'poly-reference-filter-label',
      text: 'Referenzen filtern:',
    }).appendTo($referenceFilter);

    const $filterItems = $('<div>', {
      class: 'poly-reference-filter-items',
      'data-poly-reference-filter': '',
    }).appendTo($referenceFilter);


    Object.keys(categoryMap).forEach((key) => {
      $('<div>', {
        class: 'poly-reference-filter-item',
        'data-reference-filter-item': '',
        'data-target': key,
        text: categoryMap[key],
      }).appendTo($filterItems);
    });

    const $filterTriggers = $('[data-reference-filter-item]');
    $filterTriggers.on('click', (event) => {
      const $target = $(event.currentTarget);
      handleFilter($target, $filterTriggers, $cards);
    });

    const queryParams = new URLSearchParams(window.location.search);
    const filtersParams = queryParams.get('filter') ? queryParams.get('filter').split(',') : [];
    if (filtersParams.length) {
      filtersParams.forEach((key) => {
        const filterEl = $(`[data-target=${key}]`);
        if (!filterEl.hasClass('active')) {
          filterEl.click();
        }
      });
      document.getElementById('referenceFilter').scrollIntoView();
    }
  }
}
